import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Slider } from '@mui/material';
import React, { useContext, useState } from 'react';
import { ActivityRecordingContext } from '../ActivityRecordingProvider';
import CreateSessionHighlightModal from '../SessionHighlights/CreateSessionHighlight/CreateSessionHighlightModal';
import TooltipValueLabelComponent from '../TooltipValueLabelComponent';
import { formatSeconds } from '../util';
import AddHighlightMarker from './AddHighlightMarker';
import EventMarkers from './EventMarkers';

const EventsTimelineRoot = styled('div')(() => ({
    paddingLeft: 24,
    paddingRight: 24,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 6,
    '& .MuiSlider-root': {
        marginTop: -4,
        '& .MuiSlider-rail': {
            height: 5,
            borderRadius: 4,
            backgroundColor: '#BCCCDC'
        },
        '& .MuiSlider-track': {
            height: 5,
            borderRadius: 4,
            backgroundColor: '#486581'
        },
        '& .MuiSlider-thumb': {
            height: 15,
            width: 15,
            borderRadius: 12,
            marginLeft: -7,
            backgroundColor: '#243B53'
        }
    },
    // Only show the AddHighlightMarker when the timeline area is hovered.
    '&:hover': {
        '& .VL-AddHighlightMarker': {
            visibility: 'visible',
            opacity: 1
        }
    }
}));


const EventsTimeline = ({ showReactionFeatures }) => {

    const {
        recordingId,
        videoRecordingUrl,
        videoPlayerRef,
        videoPlaybackProgress,
        videoDuration,
        setVideoIsPlaying,
        clipStartTime,
        clipDuration
    } = useContext(ActivityRecordingContext);

    const [isCreatingSessionHighlight, setIsCreatingSessionHighlight] = useState(false);

    // Temp slider value to use when seeking using the timeline. Ensures that videoPlaybackProgress
    // doesn't interfere when video is playing.
    const [tempSeek, setTempSeek] = useState(null);

    const clipStart = clipStartTime ?? videoPlaybackProgress.playedSeconds;
    const clipEnd = clipDuration ? clipStart + clipDuration : null;

    return (
        <EventsTimelineRoot>
            <div style={{ position: 'relative', height: 36 }}>
                { showReactionFeatures && <EventMarkers /> }

                <AddHighlightMarker
                    onClick={() => {
                        setVideoIsPlaying(false);
                        setIsCreatingSessionHighlight(true);
                    }}
                />
            </div>
            <Slider
                value={tempSeek ?? videoPlaybackProgress.playedSeconds}
                min={0}
                max={videoDuration}
                step={1}
                onChange={(event, value) => {
                    setTempSeek(value);
                }}
                onChangeCommitted={(event, value) => {
                    videoPlayerRef.current.seekTo(value);
                    setTimeout(() => setTempSeek(null), 300);
                }}
                valueLabelDisplay={'auto'}
                valueLabelFormat={(x) => {
                    return formatSeconds(x);
                }}
                ValueLabelComponent={TooltipValueLabelComponent}
            />
            <CreateSessionHighlightModal
                recordingId={recordingId}
                isOpen={isCreatingSessionHighlight}
                onClose={() => setIsCreatingSessionHighlight(false)}
                videoRecordingUrl={videoRecordingUrl}
                clipStartTime={clipStart}
                clipEndTime={clipEnd}
                onHighlightCreated={() => setIsCreatingSessionHighlight(false)}
            />
        </EventsTimelineRoot>
    );
};

EventsTimeline.propTypes = {
    showReactionFeatures: PropTypes.bool
};

export default EventsTimeline;
